export const initialFilter = {
  searchText: "",
  pageNumber: 1,
  pageSize: 5,
};
